import { ReactElement } from "react";
import IndicatorHeader from "../IndicatorHeader";
import IndicatorBadge from "../../../../../components/Shared/IndicatorBadge";
import styles from "./IndicatorItem.module.scss";
import { useHistory } from "react-router-dom";
import { useDependency } from "../../../../../contexts/DependencyContext";
import { WidgetService } from "../../../../../services/widgets/WidgetService";
import { IIndicatorResult } from "../../../../../services/http/indicatorlist/models/IIndicatorResult";

interface IIndicatorProps
{
    indicator: IIndicatorResult;
    componentId: number;
    widgetId: number;
    statusHistoryId: number | undefined;
    componentName: string;
}

function IndicatorItem(props: IIndicatorProps): ReactElement
{
    const history = useHistory();
    const widgetService = useDependency(WidgetService);

    function createMarkup(conditionTextHtml: string)
    {
        return {__html: conditionTextHtml};
    }

    function navigate()
    {
        if (props.statusHistoryId)
        {
            const params = `?id=${indicator.indicatorId}&name=${indicator.name}`
            history.push(`/dashboard/${indicator.componentId}/${widgetService.fullscreenWidgets.indicatorStatusHistory}/${props.statusHistoryId}/${params}`);
        }
    }

    const { indicator } = props;

    return (
        <div className={styles.wrapper}>
            <IndicatorHeader {...props} displayGaugeInfo={false} displayGaugeGraphic={false} />
            {indicator.description && <p className={styles.indicatorDescription}>{indicator.description}</p>}

            <div className={styles.content}>
                <div className={styles.status}>
                    <IndicatorBadge statusId={indicator.statusId} statusName={indicator.statusName} />
                    <p>{indicator.summary}</p>
                </div>
                <div className={styles.conditionsWrapper}>
                    {indicator.conditions.length > 0 &&
                        <span>Triggering conditions</span>
                    }
                    {indicator.conditions.map((x, i) => <div key={i} dangerouslySetInnerHTML={createMarkup(x.conditionText)}></div>)}

                </div>
                {props.statusHistoryId && <button onClick={() => navigate()}>See history</button>}
            </div>
        </div>
    );
}

export default IndicatorItem;